<template>
    <div class="live-list-section">
        <!-- 4直播 新修改-->
        <!-- 两种  -->
        <!-- <div v-else-if="dataItem.live_status == 1" class="live-list-section-left-zl live-broadcast1">
            <img src="/static/v4/assembly/activity_list_live_icon.gif" alt="" />
            <span>直播中</span>
        </div> -->
        <van-row @click="go_live_detail(dataItem, dataItem)">
            <div class="live-list-section-box">
                <div class="live-list-section-left">
                    <img class="live-list-section-left-img" :src="dataItem.cover_img" />
                    <div class="live-list-section-left-top" v-if="dataItem.top == 1">
                        <img src="/static/bytx/tag_top.svg" alt="" />
                    </div>
                    <div v-else-if="dataItem.type == 2" class="live-list-section-left-zl">
                        <img src="/static/two/icon_list_tag_subject_live.svg" alt="" />
                    </div>
                    <div v-else-if="dataItem.live_status == 0" class="live-list-section-left-zl">
                        <img src="/static/v4/assembly/icon_list_tag_live_count_down.svg" alt="" />
                    </div>
                    <div v-else-if="dataItem.live_status == 1" class="live-list-section-left-zl">
                        <img src="/static/v4/assembly/icon_list_tag_live_process.svg" alt="" />
                    </div>

                    <div v-else class="live-list-section-left-zl">
                        <img src="/static/v4/assembly/icon_list_tag_live_history.svg" alt="" />
                    </div>
                    <div class="live-list-section-left-time" v-if="dataItem.duration_format">
                        <span>{{ dataItem.duration_format }}</span>
                    </div>
                </div>
                <div class="live-list-section-right">
                    <div class="live-list-section-right-title" v-html="dataItem.title"></div>
                    <div class="live-list-section-right-detail" style="bottom: 0">
                        <span v-if="dataItem.type !== 2 && dataItem.type !== 1">{{ dataItem.start_at }}</span>
                        <span v-else-if="dataItem.type == 2">已开展{{ dataItem.current_count }}期 | 共{{ dataItem.live_count }}期</span>
                        <span v-else-if="dataItem.type !== 2 && dataItem.live_status >= 2">{{ dataItem.view_count }}人观看</span>
                        <span v-if="dataItem.type !== 2 && dataItem.live_status !== 5" class="">
                            <span v-if="dataItem.live_status !== 0" class="live-list-section-right-detail-join">{{ '加入' }}</span>
                            <span v-else :class="[dataItem.isAppointment ? 'reserved' : 'live-list-section-right-detail-join']"
                                >{{ dataItem.isAppointment ? '已预约' : '一键预约' }}
                            </span>
                        </span>
                    </div>
                </div>
            </div>
        </van-row>
    </div>
</template>

<script>
import Interface from '@/util/interface'

export default {
    props: {
        dataItem: {
            type: Object,
            required: true
        }
    },

    methods: {
        go_live_detail(item, i) {
            Interface.goLive(this, item.id, item.type, item.live_status)
            this.getViewCount(i)
        },
        getViewCount(item) {
            Interface.getData('get', `/course-phase/api/recommend_v2/${item.id}/view`)
        }
    }
}
</script>

<style lang="scss" scoped>
.live-list-section {
    border-bottom: 1px solid #f2f2f2;
    padding: 10px 0 10px 0;
    background-color: #ffffff;
    // margin: 10px 10px;
    border-radius: 10px 10px 0px 0px;
    &-title {
        font-family: PingFangSC-Semibold;
        font-size: 20px;
        color: #222222;
        letter-spacing: 0;
        margin-left: 16px;
        font-weight: 500;
        position: relative;
        span {
            position: absolute;
            bottom: 0vw;
            left: 0;
            width: 30px;
            height: 6px;
            background-color: #c7f3e7;
            border-radius: 0.8vw;
            z-index: 1;
        }
    }

    &-box {
        width: 355px;
        height: 72px;
        position: relative;
        padding-bottom: 15px;
        padding-bottom: 0;
    }

    &-left {
        width: 112px;
        height: 66px;
        float: left;
        position: relative;
        border-radius: 6px;
        margin-left: 10px;
        &-img {
            width: 112px;
            height: 66px;
            background: #eff3fa;
            border-radius: 6px;
            >>> .van-image__img,
            img {
                border-radius: 6px;
            }
        }
        &-zl {
            position: absolute;
            top: 1px;
            left: 1px;
            font-family: PingFangSC-Medium;
            font-size: 10px;
            color: #ffffff;
        }

        // 直播中
        .live-broadcast1 {
            height: 18px;
            background: #f83e48;
            border-radius: 6px 2px 6px 2px;
            display: flex;
            align-items: center;

            span {
                display: inline-block;
                margin-left: -3px;
                color: #ffffff;
                font-size: 10px;
                transform: scale(0.8, 0.8);
            }

            img {
                width: 14px;
                height: 18px;
            }
        }
        &-time {
            width: 100%;
            bottom: 0px;
            position: absolute;
            color: #fff;

            font-family: Avenir-Heavy;
            font-size: 11px;
            letter-spacing: 0;
            text-align: right;

            background-image: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(0, 0, 0, 0.4) 100%);
            border-radius: 0 0 6px 6px;

            span {
                display: inline-block;
                margin-bottom: 4px;
                margin-right: 8px;
            }
        }
        &-top {
            position: absolute;
            top: 4px;
            left: 4px;
            width: 18px;
            height: 18px;
            border-radius: 3px;
            img {
                width: 18px;
                height: 18px;
                border-radius: 3px;
            }
        }
    }

    &-right {
        float: left;
        margin-left: 10px;
        width: 205px;
        text-align: left;
        &-title {
            font-family: PingFangSC-Medium;
            font-size: 15px;
            color: #222222;
            letter-spacing: 0;
            line-height: 22px;
            font-weight: 500;
            // text-align: justify;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            word-break: break-all;
            .light {
                color: #0fb7ad;
            }
        }
        &-author {
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #404040;
            letter-spacing: 0;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
            word-break: break-all;
        }
        &-detail {
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #9d9d9d;
            letter-spacing: 0;
            vertical-align: bottom;
            position: absolute;
            bottom: 15px;
            width: 220px;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            //overflow: hidden;
            word-break: break-all;
            &-join {
                float: right;
                display: inline-block;
                font-family: PingFangSC-Medium;
                font-size: 13px;
                color: #d81d20;
                background: #ffece8;
                border-radius: 16.5px;
                padding: 5px 15px;
                margin-top: -10px;
            }
        }
    }

    .live-list-section-right {
        width: 193px;
    }
    .live-list-section {
        padding-top: 14px;
        margin-top: 0px;

        // .course-list-section-right-title,
        .live-list-section-right-title {
            padding-right: 14px;
            font-size: 15px;
            font-family: PingFangSC-Medium, PingFang SC;
        }
    }
}

.reserved {
    border-radius: 16.5px;
    margin-top: -10px;
    display: inline-block;
    float: right;
    width: 68px;
    height: 30px;
    background: #dddddd4d;
    border-radius: 17px;
    font-size: 13px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #907970;
    line-height: 30px;
    text-align: center;
}

.ellipsis-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>



// WEBPACK FOOTER //
// src/views/course/components/live-preview.vue